import React from 'react';

import Header from '../Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = (props) => {
  return (
    <>
      <div className="odc-official-pages">
        {props.children}
      </div>
    </>
  );
};

export default Layout;